import { Routes, Route } from "react-router-dom"
import CalculatorPage from "@/pages/CalculatorPage"

export default function App() {
  return (
    <Routes>
      <Route path="/*" element={<CalculatorPage />} />
    </Routes>
  )
}
